module.exports = __webpack_public_path__ + "static/media/data_collection.92b1845b.svg";